<template>
  <div>
    <el-form class="form" label-width="100px" ref="ruleForm" :model="form" :rules="rules">
      <el-form-item label="用户ID：" prop="userIds">
        <el-input
          v-model="form.userIds"
          type="textarea"
          rows="6"
          resize="none"
          placeholder="请输入用户ID，多个用 ' , ' 分隔（最多100个）"
        />
      </el-form-item>
      <el-form-item label="：" prop="clubId">
        设置近七天德州数据（对应30天、生涯数据将根据规则相应调整）
      </el-form-item>
      <el-form-item label="局数:">
        <div class="item">
          <el-input min="0" v-model="form.weekGameCntMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" v-model="form.weekGameCntMax" placeholder="最大值" />
          <span class="ml-10">局</span>
        </div>
      </el-form-item>
      <el-form-item label="总手数:">
        <div class="item">
          <el-input min="0" v-model="form.weekTotalHandMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" v-model="form.weekTotalHandMax" placeholder="最大值" />
          <span class="ml-10">手</span>
        </div>
      </el-form-item>
      <el-form-item label="入池率:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekPoolRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekPoolRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="入池胜率:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekPoolWinRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekPoolWinRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="allin胜率:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekAllinWinRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekAllinWinRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="激进率:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekAfRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekAfRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="翻牌前加注:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekPrfRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekPrfRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="翻前再加注:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekBet3RateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekBet3RateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="持续下注:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekCbetRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekCbetRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <el-form-item label="摊牌率:">
        <div class="item">
          <el-input min="0" max="100" v-model="form.weekTanpaiRateMin" placeholder="最小值" />
          <span class="cetenLine"></span>
          <el-input min="0" max="100" v-model="form.weekTanpaiRateMax" placeholder="最大值" />
          <span class="ml-10">%</span>
        </div>
      </el-form-item>
      <div class="btn-comfir">
        <el-button type="primary" @click="submitForm('ruleForm')">确认修改</el-button>
      </div>
    </el-form>
  </div>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      loading: false,
      popoverValue: false,
      form: {
        userIds: '',
        weekAfRateMax: '',
        weekAfRateMin: '',
        weekAllinWinRateMax: '',
        weekAllinWinRateMin: '',
        weekBet3RateMax: '',
        weekBet3RateMin: '',
        weekCbetRateMax: '',
        weekCbetRateMin: '',
        weekGameCntMax: '',
        weekGameCntMin: '',
        weekPoolRateMax: '',
        weekPoolRateMin: '',
        weekPoolWinRateMax: '',
        weekPoolWinRateMin: '',
        weekPrfRateMax: '',
        weekPrfRateMin: '',
        weekTanpaiRateMax: '',
        weekTanpaiRateMin: '',
        weekTotalHandMax: '',
        weekTotalHandMin: '',
      },
      rules: {
        userIds: [
          { required: true, message: '请输入用户ID', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (value.split(',').length > 100) {
                callback(new Error('用户ID最多100个'));
              } else {
                callback();
              }
            },
            trigger: 'blur',
          },
        ],
      },
      failUsers: [],
      successUsers: [],
    };
  },
  methods: {
    ...mapActions('user', ['updateUserData']),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateUserData(this.form).then(() => {
            this.$message.success('请求成功');
            // this.successUsers = res.data.successUsers;
            // this.failUsers = res.data.failUsers;
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tip {
  padding: 5px 30px;
  font-size: 14px;
  color: #666;
}

.form {
  width: 550px;
  // :global(.el-button) {
  //     // width: 80px;
  // }
}

.club_id {
  display: inline-block;
  width: 180px;
  vertical-align: middle;
}

.club_name {
  display: inline-block;
  width: 260px;
  margin-left: 10px;
  vertical-align: middle;
}
span.cetenLine {
  width: 60px;
  border: 1px solid #d6d6d6;
  height: 1px;
  margin: 0 10px;
}
.item {
  display: flex;
  align-items: center;
}
.ml-10 {
  margin-left: 10px;
}
.btn-comfir {
  text-align: center;
}
</style>
